module.exports = __webpack_public_path__ + "img/5_25.48b9a963.png";